/** Staged rollout groups, in the order a release moves through them. */
export const RINGS = [
  { key: "internal", label: "Internal", hint: "Your own test shops" },
  { key: "early", label: "Early", hint: "Friendly shops who get things first" },
  { key: "general", label: "General", hint: "Everyone else (the default)" },
];

export const RING_STYLE = {
  internal: "bg-violet-100 text-violet-800",
  early: "bg-sky-100 text-sky-800",
  general: "bg-gray-100 text-gray-600",
};
